import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoadSliderInputRanges, LoadSliderInputValues } from '../models';
import { INITIAL_LOAD_RANGES, INITIAL_LOAD_VALUES } from '../constants';

export interface LoadState {
    showLoadInertiaLowDialog: boolean;
    showLoadInertiaHighDialog: boolean;
    loadSliderTexts: LoadSliderInputValues;
    loadSliderRanges: LoadSliderInputRanges;
}

const initialState: LoadState = {
    showLoadInertiaLowDialog: false,
    showLoadInertiaHighDialog: false,
    loadSliderTexts: INITIAL_LOAD_VALUES,
    loadSliderRanges: INITIAL_LOAD_RANGES
};

export const loadSlice = createSlice({
    name: 'motor',
    initialState,
    reducers: {
        setLoadSliderTexts: (state: LoadState, action: PayloadAction<Partial<LoadSliderInputValues>>) => {
            state.loadSliderTexts = { ...state.loadSliderTexts, ...action.payload };
        },
        setLoadSliderRanges: (state: LoadState, action: PayloadAction<Partial<LoadSliderInputRanges>>) => {
            state.loadSliderRanges = { ...state.loadSliderRanges, ...action.payload };
        },
        setLoadInertiaLowDialog: (state: LoadState, action: PayloadAction<boolean>) => {
            state.showLoadInertiaLowDialog = action.payload;
        },
        setLoadInertiaHighDialog: (state: LoadState, action: PayloadAction<boolean>) => {
            state.showLoadInertiaHighDialog = action.payload;
        }
    }
});

export const {
    setLoadSliderTexts,
    setLoadSliderRanges,
    setLoadInertiaLowDialog,
    setLoadInertiaHighDialog
} = loadSlice.actions;
export const loadReducer = loadSlice.reducer;
